import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { TpvAcceptanceRate } from './TpvAcceptanceRate'
import TpvReport from './TpvReport'
import { useLazyQuery } from '@apollo/client'
import {
  GET_QC_DASHBOARD,
  GET_TPV_RECORDING_LIST,
} from '../../../../utils/GraphQLAPI'
import { useNavigate, useParams } from 'react-router-dom'
import moment from 'moment'
import DateRangePickers from '../../../sharedComponent/DateRangePickers/DateRangePickers'
import SalesChannelFilter from './SalesChannelFilter'
import AgentsFilter from './AgentsFilter'
import PendingTPVList from './PendingTPVList'
import { filterOptions } from '../../../../utils/Global.types'
const dateFormat = 'YYYY-MM-DD'
const fetchPolicy = 'network-only'


const initialRecordingFilter: filterOptions = {
  page: 1,
  perPage: 10,
  utilityId: "",
  commodityId: "",
  contractTypeId: "",
  customerTypeId: "",
  tpvStatus: "",
  qcStatus: 'PENDING',
  fromDate: new Date(
    moment(moment().subtract(29, 'days').toDate()).format(dateFormat) + 'T00:00:00'
  ).toISOString(),
  toDate: new Date(moment(moment().toDate()).format(dateFormat) + 'T23:59:00').toISOString(),
}
export default function QCDashboard() {
  const [qcTpvReport, setQcTpvReport] = useState<any>()
  const [qcTpvAcceptance, setQcTpvAcceptance] = useState<any>()
  const [tpvRecordingData, setTpvRecordingData] = useState<any>()

  const [filterOptions, setFilterOptions] = useState<any>({
    agentIds: null,
    saleChannelsIds: null,
    fromDate: new Date(
      moment(moment().subtract(29, 'days').toDate()).format(dateFormat) + 'T00:00:00'
    ).toISOString(),
    toDate: new Date(moment(moment().toDate()).format(dateFormat) + 'T23:59:00').toISOString(),
  })
  const [recordingFilter, setRecordingFilter] = useState<filterOptions>(initialRecordingFilter)

  const navigate = useNavigate()
  const getUrlParams = useParams()
  const openQcEdit = (objItem: any) => {
    navigate(`/${getUrlParams.adminUser}/qc-dashboard/customer-details`, {
      state: {
        tpvDetails: {
          tpvId: objItem.tpvId,
          tpvStatus: objItem.tpvStatus,
          qcStatus: objItem.qcStatus,
          disposition: objItem.disposition?.length > 0 ? objItem.disposition : '',
          enrollmentPosition: objItem.enrollmentPosition
        },
      },
    })
  }

  // Getting Dashboard Data
  const [getQcDashboardData, { loading: reload }] = useLazyQuery(GET_QC_DASHBOARD, {
    fetchPolicy,
    onCompleted: (data) => {
      setQcTpvReport(data?.getQcDashboard?.tpvReport)
      setQcTpvAcceptance(data?.getQcDashboard?.tpvAcceptanceRate)
    },
  })

  const [getTPVRecordingList, { loading: tpvListLoading }] = useLazyQuery(GET_TPV_RECORDING_LIST, {
    variables: {
      getTpvsInput: {
        agentlIds: filterOptions.agentIds,
        salesChannelIds: filterOptions.saleChannelsIds,
        page: recordingFilter.page,
        perPage: recordingFilter.perPage,
        tpvStatus: Boolean(recordingFilter.tpvStatus) ? [recordingFilter.tpvStatus] : null,
        qcStatus: ["PENDING"],
        fromDate: recordingFilter.fromDate,
        toDate: recordingFilter.toDate
      },
    },
    fetchPolicy,
    onCompleted: (data: any) => {
      setTpvRecordingData(data)
    },
  })
  useEffect(() => {
    getQcDashboardData({
      variables: {
        qcDashboardInput: filterOptions,
      },
    })
    getTPVRecordingList()
  }, [filterOptions])
  useEffect(() => {
    getTPVRecordingList()
  }, [recordingFilter])
  // Date Filter
  const getdataFromDateFilter = (fromDate: any, toDate: any, objDays: any) => {
    const qcAgentFilter = localStorage.getItem('qcagentFilter')
      ? localStorage.getItem('qcagentFilter')
      : null
    const qcSalesFilter = localStorage.getItem('qcSalesIds')
      ? localStorage.getItem('qcSalesIds')
      : null

    setRecordingFilter((prevOptions: any) => {
      return { ...prevOptions, fromDate, toDate, page: 1 }
    })
    setFilterOptions((prevOptions: any) => {
      return {
        ...prevOptions,
        agentIds: qcAgentFilter ? JSON.parse(qcAgentFilter) : null,
        saleChannelsIds: qcSalesFilter ? JSON.parse(qcSalesFilter) : null,
        fromDate,
        toDate,
      }
    })
  }
  return (
    <>
      <div className='d-flex justify-content-between align-items-center'>
        <div className='d-flex flex-column'>
          <span className='fs-3 fw-bold text-gray-900'>
            Dashboard
          </span>
          <span className='text-gray-500 fw-semibold lh-20px fs-7'>
            Home - Dashboard
          </span>
        </div>
        <div className='d-flex w-40 justify-content-evenly align-items-center'>
          <div className='mx-2'>
            {/* All Sales channel */}
            <SalesChannelFilter
              colors='white'
              setFilterOptions={setFilterOptions}
              setRecordingFilter={setRecordingFilter}
            />
          </div>
          <div className='mx-2'>
            {/* All agents  */}
            <AgentsFilter
              colors='white'
              salesChannelIds={filterOptions.saleChannelsIds}
              setFilterOptions={setFilterOptions}
              setRecordingFilter={setRecordingFilter}
            />
          </div>
          <div className='mx-2'>
            {/* Calender Filter  */}
            <DateRangePickers getdataFromDateFilter={getdataFromDateFilter} colors={'white'} />
          </div>
        </div>
      </div>
      <Row className='mt-5'>
        <Col md-6 lg-6 xl-6 mb-md-5 mb-xl-10>
          <TpvReport data={qcTpvReport} reload={reload} />
        </Col>
        <Col md-6 lg-6 xl-6 mb-md-5 mb-xl-10>
          <TpvAcceptanceRate data={qcTpvAcceptance} reload={reload} />
        </Col>
      </Row>
      <PendingTPVList
        tpvRecordingData={tpvRecordingData}
        filterOptions={recordingFilter}
        tpvListLoading={tpvListLoading}
        setFilterOptions={setRecordingFilter}
        openQcEdit={openQcEdit}
        initialFilter={initialRecordingFilter}
      />
    </>
  )
}
